import { withApollo } from "react-apollo";
import React from "react";
import DisplayErrors from "../../../Common/DisplayErrors";
import PrivilegePopUp from "./PrivilegePopUp";
import {
  getListofModulesQuery,
  createPrivilege,
} from "../../../../services/graphql/queries/roles";
import { SET_TIMEOUT_VALUE } from "../../../../constants/app-constants";
import close from "../../../../static/images/svg/Close.svg";
import SimpleReactValidator from "simple-react-validator";
import SelectComponent from "../../../Common/form-component/SelectComponent";

class PrivilegeAdd extends React.Component {
  constructor() {
    super();

    this.state = {
      descriptionErrMsg: "",
      errors: [],
      moduleValue: "",
      featureValue: "",
      listOfModules: [],
      listOfFeatures: [],
      selectedFeature: {},
      enableView: false,
      enableEdit: false,
      enableCreate: false,
      enableDelete: false,
      isSubmitDisable: false,
      visible: false,
      userType: "",
      userTypes: [
        { Id: 1, description: "Admin" },
        { Id: 4, description: "Info Portal" },
      ],
    };

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      element: (message) => <div style={{ color: "red" }}>{message}</div>,
    });

    this.submitForm = this.submitForm.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.selectPrivilegeModal = this.selectPrivilegeModal.bind(this);
    this.onModuleAndFeaturesSelected = this.onModuleAndFeaturesSelected.bind(
      this
    );
    this.handleSelect = this.handleSelect.bind(this);
  }

  submitForm(e) {
    const {
      selectedFeature,
      enableView,
      enableEdit,
      enableCreate,
      enableDelete,
      moduleValue,
      featureValue,
      userType,
    } = this.state;
    var that = this;
    e.preventDefault();

    if (this.validator.allValid()) {
      if (!moduleValue || !featureValue) {
        this.setState({
          descriptionErrMsg: "*Enter Valid description",
        });
        return;
      }
      this.props.client
        .mutate({
          mutation: createPrivilege,
          variables: {
            FeatureId: selectedFeature.Id,
            roleId: this.props.user.Id,
            viewP: enableView,
            editP: enableEdit,
            createP: enableCreate,
            deleteP: enableDelete,
            userType: parseInt(userType),
          },
          fetchPolicy: "no-cache",
        })
        .then((result) => {
          that.setState({
            userId: result.data.createFunction.function.Id,
            isSubmitDisable: false,
          });
          this.props.listMode(true);
          this.props.switchToListMode();
        })
        .catch((error) => {
          that.setState({ isSubmitDisable: false });
          error.graphQLErrors.map(({ message }, i) => {
            that.setState((prevState) => {
              return { errors: [message] };
            });
          });
          setTimeout(() => {
            that.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        });
    } else {
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
    }
  }

  selectPrivilegeModal(mode) {
    this.setState({
      visible: mode,
      errors: [],
    });
  }

  onModuleAndFeaturesSelected(moduleValue, featureValue, listOfFeatures) {
    this.setState({
      moduleValue: moduleValue,
      featureValue: featureValue,
      listOfFeatures: listOfFeatures,
      visible: false,
    });
    listOfFeatures.forEach((element) => {
      if (featureValue.split(" ")[0] == element.Id) {
        this.setState({
          selectedFeature: element,
          enableView: element.enableView,
          enableEdit: element.enableEdit,
          enableCreate: element.enableCreate,
          enableDelete: element.enableDelete,
        });
      }
    });
  }

  handleSelect(e) {
    let value = e.target.value;
    let name = e.target.name;
    this.setState((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  }

  resetForm() {
    this.setState(
      {
        descriptionErrMsg: "",
        errors: [],
        moduleValue: "",
        featureValue: "",
        selectedFeature: { description: "" },
        enableView: false,
        enableEdit: false,
        enableCreate: false,
        enableDelete: false,
      },
      () => {
        this.validator.hideMessages();
        // rerender to show messages for the first time
        // you can use the autoForceUpdate option to do this automatically`
        this.forceUpdate();
      }
    );
  }

  componentDidMount() {
    this.props.client
      .query({
        query: getListofModulesQuery,
        fetchPolicy: "network-only",
      })
      .then((result) => {
        const listOfModules = result.data.getListofModules;

        this.initialState = {
          listOfModules: listOfModules,
        };

        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }
  render() {
    const {
      isSubmitDisable,
      errors,
      visible,
      listOfModules,
      featureValue,
      selectedFeature,
      userTypes,
      userType,
    } = this.state;
    const { enableView, enableEdit, enableCreate, enableDelete } = this.state;
    return (
      <div>
        <PrivilegePopUp
          visible={visible}
          listOfModules={listOfModules}
          onCloseModal={(e) => {
            this.setState({ visible: false });
          }}
          onModuleAndFeaturesSelected={this.onModuleAndFeaturesSelected}
        />
        <div className="row m-b-25 align-items-center">
          <div className="col-md-10">
            <h1 className="heading m-b-0">Add Privilege</h1>
            <div
              className="row"
              style={{
                display: errors.length === 0 ? "none" : "block",
              }}
            >
              <div className="col-md-6">
                <div className="alert alert-success" role="alert">
                  <div className="row">
                    <DisplayErrors errors={errors} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-2 text-right">
            <a
              href="#"
              className="link-click m-l-45"
              onClick={() => this.props.listMode(true)}
            >
              <img src={close} /> Close
            </a>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="row" style={{ display: "none" }}>
              <div className="col-md-8">
                {/*Alert Section start */}
                <div className="alert alert-success m-b-35" role="alert">
                  Success
                </div>
                {/*Alert Section End */}
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-lg-5">
                <div className="form-group">
                  <label>DESCRIPTION</label>
                  <span style={{ color: "#ff0000", fontSize: "16px" }}>*</span>
                  <input
                    type="text"
                    className={
                      "form-control " +
                      (this.state.descriptionErrMsg != "" ? "is-invalid" : "")
                    }
                    placeholder="Click to select Module and Feature"
                    value={selectedFeature ? selectedFeature.description : ""}
                    onClick={(e) => {
                      this.selectPrivilegeModal(true);
                    }}
                  />
                  <div class="invalid-feedback" style={{ display: "block" }}>
                    {this.state.descriptionErrMsg}
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-1">
                <div className="form-group">
                  <label>VIEW</label>
                  <div className="checkbox-style-1">
                    <div className="form-check form-check-inline">
                      {selectedFeature && selectedFeature.enableView ? (
                        <>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox1"
                            value="option1"
                            checked={enableView ? true : false}
                            disabled={
                              selectedFeature && selectedFeature.enableView
                                ? false
                                : true
                            }
                            onChange={(e) =>
                              this.setState({
                                enableView: !enableView,
                              })
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineCheckbox1"
                          />
                        </>
                      ) : (
                        <div>NA</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-1">
                <div className="form-group">
                  <label>EDIT</label>
                  <div className="checkbox-style-1">
                    <div className="form-check form-check-inline">
                      {selectedFeature && selectedFeature.enableEdit ? (
                        <>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox2"
                            value="option1"
                            checked={enableEdit ? true : false}
                            disabled={
                              selectedFeature && selectedFeature.enableEdit
                                ? false
                                : true
                            }
                            onChange={(e) =>
                              this.setState({
                                enableEdit: !enableEdit,
                              })
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineCheckbox2"
                          />
                        </>
                      ) : (
                        <div>NA</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-1">
                <div className="form-group">
                  <label>CREATE</label>
                  <div className="checkbox-style-1">
                    <div className="form-check form-check-inline">
                      {selectedFeature && selectedFeature.enableCreate ? (
                        <>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox3"
                            value="option1"
                            checked={enableCreate ? true : false}
                            disabled={
                              selectedFeature && selectedFeature.enableCreate
                                ? false
                                : true
                            }
                            onChange={(e) =>
                              this.setState({
                                enableCreate: !enableCreate,
                              })
                            }
                          />
                          <label
                            style={{ marginLeft: "20px" }}
                            className="form-check-label"
                            htmlFor="inlineCheckbox3"
                          />
                        </>
                      ) : (
                        <div>NA</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-1">
                <div className="form-group">
                  <label style={{ marginLeft: "20px" }}>DELETE</label>
                  <div className="checkbox-style-1">
                    <div className="form-check form-check-inline">
                      {selectedFeature && selectedFeature.enableDelete ? (
                        <>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox4"
                            value="option1"
                            checked={enableDelete ? true : false}
                            disabled={
                              selectedFeature && selectedFeature.enableDelete
                                ? false
                                : true
                            }
                            onChange={(e) =>
                              this.setState({
                                enableDelete: !enableDelete,
                              })
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineCheckbox4"
                          />
                        </>
                      ) : (
                        <div style={{ marginLeft: "20px" }}>NA</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <SelectComponent
                  required
                  label={"User Type"}
                  title={"User Type"}
                  name={"userType"}
                  options={userTypes}
                  optionKey={"description"}
                  valueKey={"Id"}
                  value={userType}
                  placeholder={"Select User Type"}
                  handleChange={this.handleSelect}
                  validator={this.validator}
                  validation="required"
                  style={{ marginLeft: "15px"}}
                />
              </div>
              <div className="col-md-12 col-lg-10">
                <div className="row">
                  <div className="col-md-12 ">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={(e) => this.submitForm(e)}
                      disabled={isSubmitDisable}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-light m-l-50"
                      onClick={(e) => this.resetForm(e)}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withApollo(PrivilegeAdd);
